module.exports = __webpack_public_path__ + "images/f1cc0973cfb141658a568cdacd2692c3-IMG_6367.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living2/IMG_6367.jpg
// module id = ./src/assets/images/slides/living2/IMG_6367.jpg
// module chunks = 0